
export enum SyncState {

	Done = 0,
	InProgress = 1,
	Error = 2,
	Offline = 3

}